import React, { FC } from 'react';
import { Dialog, DialogTitle } from '@mui/material';
import { Dentist } from 'models/user';
import { useTranslation } from 'react-i18next';
import UpdateDentistForm from './update-dentist-form.component';

type UpdateDentistDialogProps = {
    dialogOpen: boolean;
    onDialogClose: () => void;
    dentistToUpdate: Dentist;
    onUserUpdated: () => void;
};
const UpdateDentistDialog: FC<UpdateDentistDialogProps> = ({
    dialogOpen,
    onDialogClose,
    dentistToUpdate,
    onUserUpdated,
}: UpdateDentistDialogProps) => {
    const { t: translate } = useTranslation('users');

    return (
        <Dialog fullWidth maxWidth="md" open={dialogOpen} onClose={onDialogClose}>
            <DialogTitle id="add-dentist-title">{translate('users:UPDATE_DENTIST')}</DialogTitle>
            <UpdateDentistForm
                onDialogClose={onDialogClose}
                dentistToUpdate={dentistToUpdate}
                onUserUpdated={onUserUpdated}
            />
        </Dialog>
    );
};

export default UpdateDentistDialog;
